import type { ConceptContentData } from "../types";
import { ConceptCodeBlock, ConceptText } from "./components";

type PhonyTargetsContent = Extract<
  ConceptContentData,
  { slug: "phony-targets" }
>;

export function PhonyTargetsConcept({
  content,
}: {
  content: PhonyTargetsContent;
}) {
  return (
    <div className="grid gap-7">
      <div className="grid items-start gap-6 lg:grid-cols-[minmax(0,1fr)_minmax(20rem,1fr)]">
        <div className="grid gap-4">
          {content.paragraphs.map((paragraph) => (
            <p key={paragraph} className="text-muted-foreground leading-7">
              <ConceptText text={paragraph} />
            </p>
          ))}
        </div>

        <ConceptCodeBlock
          caption={content.exampleCaption}
          lines={content.exampleLines}
        />
      </div>

      <div className="border-l-2 border-amber-500/60 bg-amber-50/70 px-4 py-3 dark:bg-amber-950/20">
        <p className="text-sm leading-6">
          <ConceptText text={content.callout} />
        </p>
      </div>
    </div>
  );
}
